import React from 'react';
import { useApp } from '../../context/AppContext';
import { PAYMENT_METHODS } from '../../data/constants';

export const HowItWorks = () => {
  const { t } = useApp();
  const steps = [
    { id: 's1', n: '01', title: t('how.s1.t'), desc: t('how.s1.d'), color: '#0F8B5C' },
    { id: 's2', n: '02', title: t('how.s2.t'), desc: t('how.s2.d'), color: '#F2B441' },
    { id: 's3', n: '03', title: t('how.s3.t'), desc: t('how.s3.d'), color: '#E8814A' },
  ];
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="landing-how-section">
      <h2 className="text-3xl md:text-4xl font-black tracking-tight text-[#1A1A1A] text-center">{t('how.title')}</h2>
      <div className="grid md:grid-cols-3 gap-6 mt-12">
        {steps.map((s) => (
          <div key={s.id} className="relative bg-white rounded-2xl p-8 border border-[#EFEAE0] hover:shadow-lg transition-shadow">
            <div className="text-5xl font-black mb-4" style={{ color: s.color }}>{s.n}</div>
            <h3 className="text-xl font-bold text-[#1A1A1A]">{s.title}</h3>
            <p className="text-[#7A7468] mt-2 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
        <span className="text-sm text-[#7A7468]">{t('land.payments')}</span>
        {PAYMENT_METHODS.map((p) => (
          <span key={p.id} className="px-3 py-1.5 rounded-lg bg-[#FAF7F2] border border-[#EFEAE0] text-sm font-semibold" style={{ color: p.color }}>{p.name}</span>
        ))}
      </div>
    </section>
  );
};
